import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Pipe, PipeTransform, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatDrawer } from '@angular/material/sidenav';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from "@angular/router";
import { TreeNode } from 'primeng/api';
import { Observable } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { AlertDialogComponent, AlertDialogModel } from '../../../shared/dialogs/alert/alert-dialog.component';
import { ConfirmationDialogComponent, ConfirmationDialogModel } from '../../../shared/dialogs/confirmation/confirmation-dialog.component';
import { NewFolderDialog } from '../../../shared/dialogs/new-folder/new-folder.dialog';
import { RoleDetailsDialog } from '../../../shared/dialogs/role-details/role-details.dialog';
import { IDrawerComponentLiaison } from '../../../shared/interfaces/idrawer-component-liaison';
import { FolderFormInstanceTree } from '../../../shared/models/folder-form-instance-tree.model';
import { PickerItem } from '../../../shared/models/picker-item.model';
import { RoleGroupMember } from '../../../shared/models/role-group-member.model';
import { Role } from '../../../shared/models/role.model';
import { Folder } from '../../../shared/models/site-content/folder.model';
import { FolderPermissionExpression } from '../../../shared/models/site-metadata/folder-permission-expression.model';
import { FolderRoleMember } from '../../../shared/models/site-metadata/folder-role-member.model';
import { FolderRolePermissionExpression } from '../../../shared/models/site-metadata/folder-role-permission-expression.model';
import { CurrentSiteService } from '../../../shared/services/current-site.service';
import { FolderFormInstanceTreeService } from '../../../shared/services/folder-form-instance-tree.service';
import { FolderPermissionService } from '../../../shared/services/folder-permission.service';
import { FolderService } from '../../../shared/services/folder.service';
import { MaxPickerService } from '../../../shared/services/max-picker.service';
import { RoleService } from '../../../shared/services/role.service';
import { UtilityHelper } from '../../../shared/utility.helper';
import { RoleMembershipDrawerLiaison } from './role-membership-drawer-liaison';

@Pipe({
    name: 'FilterFolderRoleMembers',
    standalone: false
})
export class FilterFolderRoleMembersPipe implements PipeTransform {
    transform(value: any, frpeId: number): any {
        if (!value) return value;
        return value.filter((frm) => frm.folderRolePermissionExpressionId == frpeId);
    }
}

@Component({
    selector: 'app-permissions',
    templateUrl: './permissions.component.html',
    styleUrls: ['./permissions.component.scss'],
    standalone: false
})
export class PermissionsComponent implements OnInit {

    private isLoading: boolean;
    private undoAction: string;
    public selectedTabIndex: number = 0;

    //TAB 1: Roles
    private membersInRoles: Array<any> = [];

    //TAB 3 (left): Permission Templates
    private sitePermissionExpressions: FolderPermissionExpression[];

    //TAB 3 (right): Folder Role Permission Expressions
    private selectedTemplateId: number;
    private selectedTemplateFRPEs: FolderRolePermissionExpression[];
    private applyToChildren: boolean = false;
    private lockFPE: boolean = false;

    //TAB 4 (left): Folder Permissions 
    private tree: FolderFormInstanceTree = null;
    private treeData: TreeNode[];
    private treeStatus: Array<any> = [];
    private selectedNode: TreeNode;
    private noFolderData: boolean;
    private selectedFolderId: number;
    private showAddEditTemplateForm: boolean = false;
    private folderRenameInProgress: boolean = false;

    //TAB 4 (right): Role Members
    private selected_Folder_FPE_ID: number;
    private selected_FPE_ID: number;
    private siteRoles: Role[] = null;
    private folderLevelRoles: Role[];
    private selectedFRPEs: FolderRolePermissionExpression[];
    private showResetFolders: boolean = true;
    private showUndo: boolean = false;

    //TAB 4: user/group picker
    public pickerItems: Observable<PickerItem[]>;
    public showLoadingIndicator: boolean;
    private pickerLoadingTmeoutId: any;

    addMemberForm: UntypedFormGroup;
    formControls: any = {
        id: -1,
        user: [{}]
    };

    addTemplateForm = this.fb.group({
        tag: '',
        name: '',
        description: ''
    });

    private drawerComponentLiaison: IDrawerComponentLiaison = null;

    @Input() rootFolderId: number;

    @Output() treeRequested: EventEmitter<any> = new EventEmitter();
    @Output() nodeSelected: EventEmitter<any> = new EventEmitter();

    @ViewChild('drawer') drawer: MatDrawer;
    @ViewChild('folderNameInput') folderNameInput: ElementRef;

    public constructor(
        private folderPermissionService: FolderPermissionService,
        private currentSiteService: CurrentSiteService,
        private roleService: RoleService,
        public dialog: MatDialog,
        private fb: UntypedFormBuilder,
        private maxPickerService: MaxPickerService,
        private folderService: FolderService,
        private route: ActivatedRoute,
        private readonly titleService: Title,
    ) { }

    ngOnInit(): void {
        this.isLoading = true;
        this.folderPermissionService.createStandardPermissionExpressions(this.site.id);
        this.loadPermissionTemplates();
        this.loadSiteRoles();
        this.getFoldersWithPermissions();
        // PJH - VNEXT-1368 - maybe even go further and delete all Undo's for the Site at this point
        // this.refreshUndo(); 
        this.addMemberForm = this.fb.group(this.formControls);
        this.initializeFilteredUsers();
        this.initializeLoadingIndicator();
        this.isLoading = false;
        this.titleService.setTitle(this.route.snapshot.data['title'] + ' for ' + this.site.name);
    }

    //Tab 1: Site Roles
    //app-permission-roles

    public get DrawerComponentLiaison(): IDrawerComponentLiaison {
        return this.drawerComponentLiaison;
    }
    public drawerClosing(): void {
        this.drawerComponentLiaison = null;
    }
    public editSiteLevelRoleMembershipClicked(role: Role): void {
        // Open a side drawer to manage roles, but only for site level roles.
        //
        // If the user has clicked the 'Manage ...' button for a folder-level
        // role, pop up a message directing them to the component's last tab.

        // Create the drawer liaison and open the drawer.
        this.drawerComponentLiaison = new RoleMembershipDrawerLiaison(role);
        this.drawer.open();
    }
    public closeDrawer(): void {
        this.drawer.close();
    }
    public get DrawerTitle(): string {
        let title: string = '';

        if (this.drawerComponentLiaison != null) {
            let roleMembershipLiaison = <RoleMembershipDrawerLiaison>this.drawerComponentLiaison;
            title = `${roleMembershipLiaison.Role.name} Members`;
        }

        return title;
    }

    public get MembersInRoles(): Array<any> {
        return this.membersInRoles;
    }
    public get ShowRoleMembersTabOnly(): boolean {
        //site admins can see all tabs
        if (this.currentSiteService.Site.siteIsAdministerable) return false;

        //users who have "Grant Permission" ability on any folder in the site can also see the Role Membership tab (3) but not Roles (1) and Templates (2)
        return this.site.currentUserCanSeeSimplePermissions;
    }

    //TAB 3: Permission Templates

    //TAB 3: Left Side: Templates [FolderPermissionExpression]

    public loadPermissionTemplates() {
        this.folderPermissionService.getSitePermissionExpressions(this.site.id).then(response => {
            this.sitePermissionExpressions = response.sort((a, b) => a.name.localeCompare(b.name));
        });
    }

    public addPermissionTemplate() {
        this.selectedTemplateId = 0;
        this.addTemplateForm.reset();
        this.showAddEditTemplateForm = true;
    }

    public editPermissionTemplate() {
        this.addTemplateForm.reset();
        let selectedTemplate: FolderPermissionExpression = this.sitePermissionExpressions.filter(t => t.id == this.selectedTemplateId)[0];
        if (selectedTemplate) {
            this.addTemplateForm = this.fb.group({
                tag: selectedTemplate.tag,
                name: selectedTemplate.name,
                description: selectedTemplate.description
            });
            this.showAddEditTemplateForm = true;
        }
    }

    public tagChangeEvent(event) {
        event.target.value = event.target.value.trim();
    }

    public savePermissionTemplate() {
        let templateToAddOrEdit: FolderPermissionExpression = new FolderPermissionExpression();
        templateToAddOrEdit.dataCollectionId = this.site.id;
        templateToAddOrEdit.tag = this.addTemplateForm.get('tag').value.trim();
        templateToAddOrEdit.name = this.addTemplateForm.get('name').value.trim();
        templateToAddOrEdit.description = this.addTemplateForm.get('description').value;
        templateToAddOrEdit.canBeSelectedForFolders = true;
        templateToAddOrEdit.isBuiltInPermissionExpressionFlag = false;
        templateToAddOrEdit.isDefaultPermissionExpressionFlag = false;

        let message: string = '';
        if (this.sitePermissionExpressions.filter(spe => spe.name == templateToAddOrEdit.name.trim() && spe.id != this.selectedTemplateId).length > 0) {
            message = `A permission template named '${templateToAddOrEdit.name}' already exists.`;
        }
        if (this.sitePermissionExpressions.filter(spe => spe.tag == templateToAddOrEdit.tag.trim() && spe.id != this.selectedTemplateId).length > 0) {
            message = `A permission template using tag '${templateToAddOrEdit.tag}' already exists.`;
        }
        if (message) {
            let dialogueData: AlertDialogModel = new AlertDialogModel("Duplicate entry", message);
            this.dialog.open(AlertDialogComponent, {
                maxWidth: "600px",
                data: dialogueData
            });
            return;
        }

        if (this.selectedTemplateId == 0) { // add new template
            this.showAddEditTemplateForm = false;

            this.folderPermissionService.createFolderPermissionExpression(0, templateToAddOrEdit).then(response => {
                this.getFoldersWithPermissions();
                this.loadPermissionTemplates();
                this.selectedTemplateFRPEs = [];
                this.refreshUndo();
            });
        } else { // edit existing template
            templateToAddOrEdit.id = this.selectedTemplateId;
            this.folderPermissionService.updateFolderPermissionExpression(templateToAddOrEdit).then(response => {
                this.getFoldersWithPermissions();
                this.loadPermissionTemplates();
                this.refreshUndo();
            });
        }
        this.addTemplateForm.reset();
        this.showAddEditTemplateForm = false;
    }

    public CancelAddPermissionTemplate() {
        this.addTemplateForm.reset();
        this.showAddEditTemplateForm = false;
    }

    public SelectTemplate(templateId: number) {
        if (this.selectedTemplateId == templateId) return;
        this.showAddEditTemplateForm = false;
        this.selectedTemplateId = templateId;
        let selectedTemplate: FolderPermissionExpression = this.sitePermissionExpressions.find(fpe => fpe.id == templateId);
        if (selectedTemplate?.folderRolePermissionExpressions) {
            this.selectedTemplateFRPEs = selectedTemplate.folderRolePermissionExpressions;
            if (this.selectedTemplateFRPEs) {
                this.selectedTemplateFRPEs.forEach(stf => {
                    stf.roleIsSiteLevel = false;
                    if (this.siteRoles.length > 0) {
                        if (this.siteRoles.filter(sr => sr.id == stf.roleId && sr.isSiteLevel).length > 0) stf.roleIsSiteLevel = true;
                    } else {
                        console.log('this.siteRoles empty during SelectTemplate');
                    }
                });
                this.selectedTemplateFRPEs = this.selectedTemplateFRPEs.sort((a, b) =>
                    ((a.roleIsSiteLevel ? "0" : "1") + a.roleName).localeCompare((b.roleIsSiteLevel ? "0" : "1") + b.roleName));
            }
        }
        else {
            console.log('No Folder Role Permissions found for template ' + templateId);
            this.selectedTemplateFRPEs = [];
        }
    }

    public deletePermissionTemplate() {
        if (this.selectedTemplateFRPEs && this.selectedTemplateFRPEs.filter(frpe => frpe.folderPermissionExpressionId == this.selectedTemplateId).length > 0) {
            let message: string = "This permission cannot be deleted while roles are assigned";
            let dialogueData: AlertDialogModel = new AlertDialogModel("Permission Template in Use", message);
            this.dialog.open(AlertDialogComponent, {
                maxWidth: "600px",
                data: dialogueData
            });
            return;
        }

        this.folderPermissionService.deleteFolderPermissionExpressionById(this.selectedTemplateId).then(res => {
            this.loadPermissionTemplates();
        });
    }

    //TAB 3: Right Side: Roles [FolderRolePermissionExpression]

    public updateFRPE(e: any, selFRPEid: any, roleId: any) {
        let frpe: FolderRolePermissionExpression = this.selectedTemplateFRPEs.find(frpe => frpe.id == selFRPEid && frpe.roleId == roleId);
        if (frpe) {
            let perm: string = e.source.id.substring(0, 10); // remove IDs appended to make checkbox controls unique
            switch (perm) {
                case 'ViewFolder':
                    frpe.canViewFolder = e.checked;
                    if (!frpe.canViewFolder) frpe.canCreateFolder = false;
                    break;
                case 'CreateFold':
                    frpe.canCreateFolder = e.checked;
                    if (frpe.canCreateFolder) frpe.canViewFolder = true;
                    break;
                case 'DeleteFold':
                    frpe.canDeleteFolder = e.checked;
                    break;
                case 'CreateForm':
                    frpe.canCreateForm = e.checked;
                    break;
                case 'DeleteForm':
                    frpe.canDeleteForm = e.checked;
                    break;
                case 'ReordrForm':
                    frpe.canReorderForms = e.checked;
                    break;
                case 'GrantPermi':
                    frpe.canGrantPermission = e.checked;
                    break;
                case 'ManagePerm':
                    frpe.canManageRoleMembers = e.checked;
                    break;
                case 'Constraint':
                    frpe.canBuildConstraints = e.checked;
                    break;
                case 'CreateWork':
                    frpe.canBuildWorkflows = e.checked;
                    break;
                case 'Can_Publis':
                    frpe.canPublish = e.checked;
                    break;
                case 'EditFormHT':
                    frpe.canEditFormTemplateHtml = e.checked;
                    break;
                case 'EditSiteHT':
                    frpe.canEditSiteHomePageHtml = e.checked;
                    break;
            }
            this.folderPermissionService.updateFolderRolePermission(frpe).then(response => {
                let refreshSelectedFRPE: FolderRolePermissionExpression = this.selectedFRPEs?.find(f => f.id == selFRPEid);
                if (refreshSelectedFRPE) {
                    refreshSelectedFRPE.canViewFolder = frpe.canViewFolder;
                    refreshSelectedFRPE.canCreateFolder = frpe.canCreateFolder;
                    refreshSelectedFRPE.canDeleteFolder = frpe.canDeleteFolder;
                    refreshSelectedFRPE.canCreateForm = frpe.canCreateForm;
                    refreshSelectedFRPE.canCreateFolder = frpe.canCreateFolder;
                    refreshSelectedFRPE.canGrantPermission = frpe.canGrantPermission;
                    refreshSelectedFRPE.canManageRoleMembers = frpe.canManageRoleMembers;
                    refreshSelectedFRPE.canBuildConstraints = frpe.canBuildConstraints;
                    refreshSelectedFRPE.canBuildWorkflows = frpe.canBuildWorkflows;
                    refreshSelectedFRPE.canPublish = frpe.canPublish;
                }
                this.getFoldersWithPermissions();
                this.refreshUndo();
            });
        }
        else {
            console.log('Error: FolderRolePermissionExpression not found for ID ' + selFRPEid);
        }
    }

    // Folders, Roles and Members tab

    public loadSiteRoles() {
        this.roleService.getSiteRoles(this.site.id).then(response => {
            this.siteRoles = response;
            this.siteRoles = this.siteRoles.sort((a, b) =>
                (a.isSiteLevel ? '0' + a.name : '1' + a.name).localeCompare(b.isSiteLevel ? '0' + b.name : '1' + b.name));
        });
    }

    updateSelectedFPE_ID(value) {
        this.selected_FPE_ID = value;
    }

    public renameFolderClick(id: number) {
        this.folderRenameInProgress = true;
        setTimeout(() => {
            this.folderNameInput.nativeElement.focus();
            this.folderNameInput.nativeElement.select();
        }, 0);
    }

    public renameFolderFocusOut() {
        this.folderRenameInProgress = false;
    }

    public renameFolder(event) {
        this.folderRenameInProgress = false;

        let folderToRename: Folder = new Folder();
        folderToRename.name = event.target.value;
        folderToRename.setId(this.selectedFolderId);

        this.folderService.rename(folderToRename).then(response => {
            this.getFoldersWithPermissions();
        });
    }

    public renameFolderCancel() {
        this.folderRenameInProgress = false;
    }

    public treeNodeKeyup(event) {
        if (event.key === 'F2') {
            if (!this.folderRenameInProgress) {
                this.renameFolderClick(this.selectedFolderId);
            }
        }
    }

    public addFolder() {
        let addToRoot = !this.selectedFolderId || this.TreeData?.length == 0;
        const dialogRef = this.dialog.open(NewFolderDialog, {
            width: '40%',
            data: {
                parentFolderId: this.selectedFolderId,
                showTransparentOption: true,
                isTransparentFolder: false,
                showRootFolderOption: true,
                isRootFolder: addToRoot
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            let folderName = result?.folderName;
            if (!folderName) return;
            if (folderName && folderName.trim().length > 0) {
                folderName = folderName.trim();
                let message: string = '';
                let isDupe: boolean = false;

                if (result.isRootFolder) {
                    if (this.tree?.childFolders?.filter(n => n.name == folderName).length > 0) {
                        message = `A folder named '${folderName}' already exists at the root level.`;
                        isDupe = true;
                    }
                } else {
                    if (this.selectedNode?.children?.filter(n => n.data.name == folderName).length > 0) {
                        message = `A folder named '${folderName}' already exists in the selected folder.`;
                        isDupe = true;
                    }
                }

                if (isDupe) {
                    let dialogueData: AlertDialogModel = new AlertDialogModel("Duplicate Name", message);
                    this.dialog.open(AlertDialogComponent, {
                        maxWidth: "600px",
                        data: dialogueData
                    });
                } else {
                    let folder = new Folder();
                    folder.name = folderName;
                    if (result.isRootFolder) {
                        folder.parentFolderId = this.tree.id;
                    } else {
                        folder.parentFolderId = this.selectedFolderId;
                    }
                    folder.helpTextFormat = "";
                    folder.helpText = "";
                    folder.dataCollectionId = this.SiteId;
                    folder.isTransparentFolder = result.isTransparentFolder;

                    this.folderService.create(folder)
                        .then(createdFolder => {
                            this.getFoldersWithPermissions();
                        });
                }
            }
        });
    }

    public deleteFolder() {
        let dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            width: "400px",
            data: new ConfirmationDialogModel(
                `Delete Folder`,
                `Are you sure you want to delete this folder and all its contents?`)
        });
        dialogRef.afterClosed().subscribe(yes => {
            if (yes) {
                this.folderService.delete(this.selectedFolderId).then(res => {
                    this.selectedFolderId = null;
                    this.folderLevelRoles = null;
                    this.getFoldersWithPermissions();
                    this.refreshUndo();
                });
            }
        });
    }

    public onDrop(event: any): void {
        let draggedNode: TreeNode = event.dragNode;
        let targetNode: TreeNode = event.dropNode;
        let isTopLevel = !targetNode.parent;

        if (event.originalEvent.target.className.match(/p-treenode-droppoint-active/)) { //dropped between nodes
            let parentId = targetNode.data.parentId;
            if ((!targetNode.parent && !draggedNode.parent) || (draggedNode.parent == targetNode.parent)) { //reording within the same folder
                let newIdsAndPositions = this.getNewIdsAndPositions(targetNode, draggedNode);

                UtilityHelper.runWhenStackClear(() => {
                    if (targetNode.data.type == 'Folder') {
                        this.folderService.reorderChildFolders(newIdsAndPositions, parentId)
                            .then(res => {
                                this.getFoldersWithPermissions();
                            });
                    } else {
                        this.folderService.reorderFormInstances(newIdsAndPositions, parentId)
                            .then(res => {
                                this.getFoldersWithPermissions();
                            });
                    }
                });
            }
            else { // moving to a position in another folder: move and set order
                let newParentFolderName = isTopLevel ? "The Top Level" : targetNode.parent.label;
                this.moveTreeNodes(draggedNode, targetNode, newParentFolderName, event, parentId, isTopLevel);
            }
        } else {
            let parentId = targetNode.data.id;
            let destName = targetNode.label;

            //ignore if dragged node is already in the destination folder
            if (draggedNode.parent && draggedNode.parent.data.id == targetNode.data.id) return;
            this.moveTreeNodes(draggedNode, targetNode, destName, event, parentId, isTopLevel);
        }
    }

    public OpenFRMTab(): void {
        this.selectedTabIndex = 3;
    }

    private moveTreeNodes(draggedNode: TreeNode, targetNode: TreeNode<any>, newParentFolderName: string, event: any, parentId: number, isTopLevel: boolean) {
        this.confirmTreeMove(draggedNode, newParentFolderName, () => {
            let newIdsAndPositions = this.getNewIdsAndPositions(targetNode, draggedNode);
            UtilityHelper.runWhenStackClear(() => {
                this.folderService.moveFolders([draggedNode.data.id], parentId).then(x => {
                    this.folderService.reorderChildFolders(newIdsAndPositions, parentId)
                        .then(res => {
                            this.getFoldersWithPermissions();
                        });
                });
            });
        });
    }

    private confirmTreeMove(movedNode: TreeNode, destinationName: String, callback: Function) {
        let dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            data: new ConfirmationDialogModel(
                `Move Folder`,
                `Are you sure you want to move the Folder "${movedNode.label}" into Folder "${destinationName}"?`)
        });
        dialogRef.afterClosed().subscribe(yes => {
            if (yes) {
                callback();
            } else {
                this.getFoldersWithPermissions();
            }
        });
    }

    private getNewIdsAndPositions(targetNode: TreeNode<any>, draggedNode: TreeNode<any>) {
        let newIdsAndPositions = {}, newNamesAndPositions = {};
        let i = 0;

        let children = this.getChildren(targetNode);
        children.forEach(node => {
            let nodeType = node.data ? node.data.type : node.type;
            let nodeId = node.data ? node.data.id : node['id'];
            if (nodeType == draggedNode.data.type) {
                newIdsAndPositions[nodeId] = i++;
                newNamesAndPositions[node.label] = i++;
            }
        });
        return newIdsAndPositions;
    }

    private getChildren(node: TreeNode<any>): TreeNode[] {
        let children: TreeNode[]

        if (node.parent) {
            children = node.parent.children;
        } else {
            children = this.treeData;
        }
        return children;
    }

    public applyToSubfoldersChecked(event) {
        this.applyToChildren = event.checked;
    }

    public lockFPEChecked(event) {
        this.lockFPE = event.checked;
    }

    public setFPEForFolder() {
        if (this.selectedFolderId == null || this.selectedFolderId == 0) {
            return;
        }
        this.folderPermissionService.assignFolderExpressionToFolder(this.selected_FPE_ID, this.selectedFolderId, this.applyToChildren, this.lockFPE).then(response => {
            let newFRPEsForFolder: FolderRolePermissionExpression[] = response?.folderRolePermissionExpressions;
            if (newFRPEsForFolder) {
                this.selectedFRPEs = [];
                newFRPEsForFolder.forEach(newFRPE => {
                    if (this.siteRoles.length > 0) {
                        if (this.siteRoles.filter(sr => sr.id == newFRPE.roleId && sr.isSiteLevel).length > 0) newFRPE.roleIsSiteLevel = true;
                    }
                    this.selectedFRPEs.push(newFRPE);
                });
            }
            this.selected_Folder_FPE_ID = this.selected_FPE_ID;
            this.getFoldersWithPermissions();
            this.refreshUndo();
        });
    }

    private initializeFilteredUsers(): void {
        this.pickerItems = this.addMemberForm.controls['user'].valueChanges.pipe(
            debounceTime(300),
            switchMap(value => this.maxPickerService.search(value))
        );
    }

    private initializeLoadingIndicator(): void {
        this.maxPickerService.isSearching.subscribe((value) => {
            if (value) {
                if (!this.showLoadingIndicator) {
                    this.pickerLoadingTmeoutId = setTimeout(() => { this.showLoadingIndicator = true }, 450);
                }
            }
            else {
                clearTimeout(this.pickerLoadingTmeoutId);
                this.showLoadingIndicator = false;
            }
        });
    }

    public addMember(frpeId: number): void {
        let rm = new RoleGroupMember(this.addMemberForm.value.user.key, this.addMemberForm.value.user.isUser);
        this.addMemberForm.reset(this.formControls);

        if (rm.member == undefined) {
            console.log('Error: Added member is undefined');
            return;
        }

        let selectedFRPE = this.selectedFRPEs.find(frpe => frpe.id == frpeId);
        if (selectedFRPE.folderRoleMembers) {
            if (selectedFRPE.folderRoleMembers.filter(m => m.folderRolePermissionExpressionId == frpeId && m.memberId == rm.member).length > 0) {
                let dialogueData: AlertDialogModel = new AlertDialogModel("Duplicate member", "That member has already been added.");
                this.dialog.open(AlertDialogComponent, {
                    maxWidth: "600px",
                    data: dialogueData
                });
                return;
            }
        }

        let frm: FolderRoleMember = new FolderRoleMember(this.selectedFolderId, frpeId, rm.memberType, rm.member, rm.memberId);
        frm.addToAllSharingTheRolePermission = false; // We don't want to add this role member to every folder that uses this folder role permission expression.

        this.folderPermissionService.addFolderRoleMember(frm).then(response => {
            this.folderPermissionService.getSiteFolderWithPermissions(this.selectedFolderId).then(response => {
                this.refreshFolderPermissions();
            });
            this.refreshUndo();
        });
    }

    public removeFolderRoleMember(FRPE: FolderRolePermissionExpression, member: FolderRoleMember): void {
        let frmDel: FolderRoleMember = new FolderRoleMember(member.folderId, FRPE.id, member.memberType, member.member, member.memberId);
        this.folderPermissionService.removeFolderRoleMember(frmDel).then(response => {
            let selectedFRPE = this.selectedFRPEs.find(frpe => frpe.id == FRPE.id);
            selectedFRPE.folderRoleMembers = selectedFRPE.folderRoleMembers.filter(rm => rm.memberId != frmDel.memberId);
            this.refreshUndo();
        });
    }

    // Used by autocomplete control
    displayUserName(pi: PickerItem): string {
        return pi.displayName;
    }

    private getFoldersWithPermissions() {
        //remember which folders were expanded
        this.treeStatus = [];
        if (this.TreeData && this.TreeData[0]) {
            this.treeStatus.push({ id: this.TreeData[0].data.id, expanded: this.TreeData[0].expanded });
            this.saveTreeStatus(this.TreeData[0]);
        }

        this.folderPermissionService.getSiteFoldersWithPermissions(this.site.id).then(response => {
            this.noFolderData = (response.childFolders == null);
            this.folderPermissionService.createStandardPermissionExpressions(this.site.id);
            this.tree = FolderFormInstanceTreeService.unpackTree(response);
            this.treeReceived(this.tree);
            if (this.treeStatus.length > 0 && this.TreeData) {
                this.restoreTreeStatus(this.TreeData[0]);
            }
            this.refreshMemberList();
        });
    }

    private saveTreeStatus(tn: TreeNode) {
        for (let n of tn.children) {
            this.treeStatus.push({ id: n.data.id, expanded: n.expanded });
            if (n.children) { this.saveTreeStatus(n); }
        }
    }

    private restoreTreeStatus(tn: TreeNode) {
        let status = this.treeStatus.find(ts => ts.id == tn.data.id);
        if (status) tn.expanded = status.expanded;
        if (tn.children) {
            tn.children.forEach(tc => this.restoreTreeStatus(tc));
        }
    }

    public updateSiteFoldersWithPermissions() {
        //refresh FolderLevelRoles.role and role.members without reloading tree display
        this.folderPermissionService.getSiteFoldersWithPermissions(this.site.id).then(response => {
            this.tree = FolderFormInstanceTreeService.unpackTree(response);
            this.treeReceived(this.tree);
            this.refreshMemberList();
        });
    }

    private refreshMemberList() {
        this.membersInRoles = [];
        if (this.treeData != null) { // 01-30-2024:  added this line after encountering a JavaScript exception when this.treeData was null or undefined.
            this.treeData.forEach(td => {
                if (td.data && td.data.folderPermissionExpression && td.data.folderPermissionExpression.folderRolePermissionExpressions) {
                    td.data.folderPermissionExpression.folderRolePermissionExpressions.forEach(frpe => {
                        if (frpe.folderRoleMembers) {
                            frpe.folderRoleMembers.forEach(frm => {
                                this.membersInRoles.push({ roleId: frpe.roleId, folderId: frm.folderId, memberName: frm.member });
                            });
                        }
                    });
                }
            });
        }
    }

    private refreshUndo() {
        this.showUndo = false;
        this.folderPermissionService.getSiteExecutableUndoActions(this.site.id, "FolderPermission").then(response => {
            if (response.length > 0) {
                if (response[0].undoStatus == 'Created') {
                    this.undoAction = response[0].undoType;
                    this.showUndo = true;
                }
            }
        });
    }

    public get IsLoading(): boolean {
        return this.isLoading;
    }
    public get UndoAction(): string {
        return this.undoAction;
    }
    public get SitePermissionExpressions(): FolderPermissionExpression[] {
        return this.sitePermissionExpressions;
    }
    public get SelectedTemplateId(): number {
        return this.selectedTemplateId;
    }
    public get SelectedTemplateFRPEs(): FolderRolePermissionExpression[] {
        return this.selectedTemplateFRPEs?.sort((a, b) =>
            ((a.roleIsSiteLevel ? "0" : "1") + a.roleName).localeCompare((b.roleIsSiteLevel ? "0" : "1") + b.roleName));
    }
    public get TreeData(): TreeNode[] {
        return this.treeData;
    }
    public get SelectedNode(): TreeNode {
        return this.selectedNode;
    }
    public set SelectedNode(val: TreeNode) {
        this.selectedNode = val;
    }
    public get SelectedFolderId(): number {
        return this.selectedFolderId;
    }
    public get FolderRenameInProgress(): boolean {
        return this.folderRenameInProgress;
    }
    public get NoFolderData(): boolean {
        return this.noFolderData;
    }
    public get ShowAddEditTemplateForm(): boolean {
        return this.showAddEditTemplateForm;
    }
    public get Selected_Folder_FPE_ID(): number {
        return this.selected_Folder_FPE_ID;
    }

    //TAB 4 folder role members
    public get SelectedFRPEs(): FolderRolePermissionExpression[] {
        //remove instance var selectedFRPEs, calculate when needed with api lookup

        if (this.selectedFRPEs) return this.selectedFRPEs.sort((a, b) =>
            ((a.roleIsSiteLevel ? "0" : "1") + a.roleName).localeCompare((b.roleIsSiteLevel ? "0" : "1") + b.roleName));
    }
    public get ShowResetFolders(): boolean {
        return this.showResetFolders;
    }
    public get ShowUndo(): boolean {
        return this.showUndo;
    }
    public get site() {
        return this.currentSiteService.Site;
    }
    public get SiteRoles(): Role[] {
        return this.siteRoles;
    }
    public get SiteRolesLoaded(): boolean {
        return this.siteRoles != null;
    }
    public get RootFolderId(): number {
        return this.currentSiteService.Site.folders[0].id;
    }
    public get SiteId(): number {
        return this.currentSiteService.Site.id;
    }
    public get SiteName(): string {
        return this.currentSiteService.Site.name;
    }
    public get FolderLevelRoles(): Role[] {
        return this.folderLevelRoles?.sort((a, b) =>
            ((a.isSiteLevel ? '1' : '0') + a.name).localeCompare((b.isSiteLevel ? '1' : '0') + b.name));
    }
    public MemberDisplayName(frm: FolderRoleMember): string {
        if (frm.memberType == 'User') {
            return frm.member + " (" + frm.memberId + ")";
        }
        else {
            return frm.member;
        }
    }

    public selectFolderInTree(e: any) {
        let node = e.node;
        if (this.selectedFolderId != node.data.id) {
            this.selectedFolderId = node.data.id;
            this.selected_Folder_FPE_ID = node.data.FPE_ID;
        }
        this.selectedFRPEs = node.data.FRPE;
        if (this.selectedFRPEs) {
            this.selectedFRPEs.forEach(frpe => {
                frpe.roleIsSiteLevel = false;
                if (this.siteRoles.length > 0) {
                    if (this.siteRoles.filter(sr => sr.id == frpe.roleId && sr.isSiteLevel).length > 0) frpe.roleIsSiteLevel = true;
                } else {
                    console.log('this.siteRoles empty during selectFolderInTree');
                }
            });
        }
        this.refreshFolderPermissions();
        // Commented out for VNEXT-1368
        // this.showUndo = false;
    }

    public refreshFolderPermissions() {

        this.folderPermissionService.getSiteFolderWithPermissions(this.selectedFolderId).then(response => {
            let fpe: FolderPermissionExpression = response?.folderPermissionExpression;
            if (fpe)
                this.selectedFRPEs = fpe.folderRolePermissionExpressions;

            // 06-14-2024 note:  since endpoint FolderPermissionService.getSiteFolderWithPermissions() no longer returns
            //                   the folder's roles directly, we have to get them from the folder role permission expressions.
            //
            // Note:  it would be better to derive the this.selectedFolderMembers value when needed rather than building it
            //        here and saving it as this would eliminate an instance variable that is prone to getting out of sync
            //        with the this.selectedFRPEs instance variable.

            if (this.selectedFRPEs != null) {
                for (let rolePermissionExprIndex: number = 0; rolePermissionExprIndex < this.selectedFRPEs.length; rolePermissionExprIndex++) {
                    let rolePermissionExpr: FolderRolePermissionExpression = this.selectedFRPEs[rolePermissionExprIndex];
                    let membersInFolder: FolderRoleMember[] = [];
                    if (rolePermissionExpr.folderRoleMembers != null) {
                        for (let memberIndex: number = 0; memberIndex < rolePermissionExpr.folderRoleMembers.length; memberIndex++) {
                            let roleMember: FolderRoleMember = rolePermissionExpr.folderRoleMembers[memberIndex];
                            if (roleMember.folderId == this.selectedFolderId) {
                                membersInFolder.push(roleMember);
                            }
                        }
                    }
                    this.selectedFRPEs[rolePermissionExprIndex].folderRoleMembers = membersInFolder;
                }
            }
        });
    }

    public assignDefaultToAll(): void {
        let dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            width: "400px",
            data: new ConfirmationDialogModel(
                `Assign Default to All Folders`,
                `Are you sure you want to reset all folders to the default permission template? \n This will overwrite current settings.`)
        });
        dialogRef.afterClosed().subscribe(yes => {
            if (yes) {
                this.folderPermissionService.assignDefaultPermissionExpressionToAllFolders(this.site.id);
                this.showResetFolders = false;
                this.getFoldersWithPermissions();
                this.refreshUndo();
            }
        });
    }

    public undo(): void {
        this.folderPermissionService.undoLastPermissionApplied(this.site.id).then(x => {
            this.refreshFolderPermissions();
            this.refreshUndo();
        });
    }

    // 'Roles'-related control actions.
    public roleIsSiteLevel(role: Role): boolean {
        return role.isSiteLevel;
    }
    public toggleRoleIsSiteLevelSelection(role: Role): void {
        role.isSiteLevel = !role.isSiteLevel;
    }

    // Helper methods.
    private filterFolders(tree: FolderFormInstanceTree) {
        this.treeData = this.rawTreeToTreeNodes(tree);
    }

    private treeReceived(tree: FolderFormInstanceTree): void {
        if (!tree.childFolders) {
            this.noFolderData = true;
            this.showResetFolders = false;
        } else {
            this.noFolderData = false;
        }
        this.filterFolders(tree);
    }

    private rawTreeToTreeNodes(tree: FolderFormInstanceTree, json: TreeNode[] = []): any {
        if (tree.parentFolderId == null) {
            this.rootFolderId = tree.id;
        }
        if ((tree.childFolders !== null) && (tree.childFolders.length > 0)) {
            this.buildTreeNode(tree.childFolders, json);
        }
        if ((tree.childFormInstances !== null) && (tree.childFormInstances.length > 0)) {
            this.buildTreeNode(tree.childFormInstances, json);
        }
        return json;
    }

    public ShowActivate(roleId: number) {
        if (this.selectedFRPEs) return this.selectedFRPEs.filter(f => f.roleId == roleId).length == 0;
        return 0;
    }

    public ShowActivateRole(roleId: number) {
        if (!this.selectedTemplateId) return false;
        if (this.selectedTemplateFRPEs.filter(frpe => frpe.roleId == roleId).length == 0) {
            return true;
        }
        else {
            return false;
        }
    }

    public activateRoleForTemplate(roleId: number) {
        //adds a FolderRolePermissionExpression record
        if (!roleId) {
            console.log('ERROR: missing Role ID');
            return;
        }
        if (roleId == 0) {
            console.log('ERROR: Role ID is zero');
            return;
        }
        if (this.selected_FPE_ID == 0) {
            console.log('ERROR: selected folder permission expression ID is zero');
            return;
        }
        let frpe: FolderRolePermissionExpression = new FolderRolePermissionExpression(this.selectedTemplateId, roleId);

        this.folderPermissionService.addFolderRolePermission(frpe).then(res => {
            this.selectedTemplateFRPEs = [];
            let refreshedFRPEs: FolderRolePermissionExpression[] = res.folderRolePermissionExpressions;
            if (refreshedFRPEs) {
                refreshedFRPEs.forEach(updatedFRPE => {
                    if (this.siteRoles?.filter(sr => sr.isSiteLevel && sr.id == updatedFRPE.roleId).length > 0) {
                        updatedFRPE.roleIsSiteLevel = true;
                    }
                    this.selectedTemplateFRPEs.push(updatedFRPE);
                    if (this.selectedFRPEs?.filter(s => s.roleId == updatedFRPE.roleId).length == 0) {
                        this.selectedFRPEs.push(updatedFRPE);
                    }
                });
            }
            this.loadPermissionTemplates();
            this.refreshUndo();
        });
    }

    public openCreateRoleDialog() {
        const dialogRef = this.dialog.open(RoleDetailsDialog);
        dialogRef.afterClosed().subscribe(newRole => {
            if (newRole != null) {
                newRole.name = newRole.name.trim();
                newRole.dataCollectionId = this.site.id;
                this.roleService.create(newRole).then(res => {
                    this.currentSiteService.addRole(res as Role);
                });
            }
        });
    }

    private buildTreeNode(treeNodes: FolderFormInstanceTree[], json: TreeNode[]) {
        for (let treeNode of treeNodes) {
            let node = {
                label: `${treeNode.name}`,
                icon: 'folder',
                iconClass: treeNode.isTransparentFolder ? 'material-icons-outlined' : '',
                type: 'Folder',
                expanded: true,
                data: {
                    id: treeNode.id,
                    name: treeNode.name,
                    parentId: treeNode.parentFolderId,
                    type: treeNode.type,
                    referencedFormInstanceId: treeNode.referencedFormInstanceId,
                    isReferenced: treeNode.isReferenced,
                    canView: treeNode.canView,
                    canEdit: treeNode.canEdit,
                    canDelete: treeNode.canDelete,
                    canGrant: treeNode.canGrant,
                    canBuildFolders: treeNode.canBuildFolders,
                    canBuildFormInstances: treeNode.canBuildFormInstances,
                    canBuildForms: treeNode.canBuildForms,
                    canBuildWorkflows: treeNode.canBuildWorkflows,
                    canCreateFolder: treeNode.canCreateFolder,
                    canCreateForm: treeNode.canCreateForm,
                    FPE_ID: treeNode.folderPermissionExpressionId,
                    templateName: treeNode.folderPermissionExpressionName,
                    tagStyle: 'tag-gray',
                    tag: treeNode.folderPermissionExpressionTag,
                    folderRoleMembers: treeNode.folderRoleMembers,
                    isTransparentFolder: treeNode.isTransparentFolder
                },
                color: "",
                children: [],
                childFolders: [],
                childFormInstances: [],
                key: treeNode.qualifiedId()
            };

            json.push(node);

            this.rawTreeToTreeNodes(treeNode, node.children);
        }
    }
}
